export const filterData = (arr: any, property: string, searchQuery: string) => {
	const filtered = arr.filter((d: any) =>
		d[property]?.toLowerCase().includes(searchQuery.toLowerCase()),
	);

	return filtered;
};
